import cx from 'classnames';

import { useNavigation } from 'hooks/navigation/useNavigation';

import { PlayHeroNavigation } from './PlayfulNavigation/PlayHeroNavigation';
import { PlayMinimalNavigation } from './PlayfulNavigation/PlayMinimalNavigation';

import s from './PlayfulHeader.module.css';

export const PlayfulHeader = () => {
  const { isHome } = useNavigation();

  return (
    <header className={cx(s.header, { [s.minimalHeader]: !isHome })}>
      {isHome ? (
        <>
          <div className={s.mobileNavContainer}>
            <PlayMinimalNavigation />
          </div>
          <PlayHeroNavigation />
        </>
      ) : (
        <PlayMinimalNavigation />
      )}
    </header>
  );
};
